import {observer} from 'mobx-react';
import React from 'react';
import {SidebarLoaderState} from '../SidebarLoaderState';
import {SidebarStore} from '../SidebarStore';
import {CollapsibleMenu} from '../CollapsibleMenu';
import {TreeComponent} from '../menu/TreeComponent';

@observer
export class SidebarContentManager extends React.Component<{ store: SidebarStore }> {
  render() {
    const store = this.props.store;

    return (
      <div className="content-manager-sidebar">
        <CollapsibleMenu label="Content Management">
          <TreeComponent tree={store.contentManagementMenu}/>
          <SidebarLoaderState store={store}/>
        </CollapsibleMenu>
      </div>
    );
  }
}
